/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * The cover picture of a program or membership: a thumbnail in lists and a
 * larger one at the top of its page. No picture shows a quiet placeholder.
 */
import React from "react";
import VariantImg from "@lemonadetraining/web-shared/components/VariantImg";

export const CoverThumb = ({ url }: { url?: string | null }) =>
  url ? (
    <VariantImg
      src={url}
      size="200x200"
      surface="coverArt"
      alt=""
      className="h-11 w-16 shrink-0 rounded-lg object-cover"
    />
  ) : (
    <span className="h-11 w-16 shrink-0 rounded-lg bg-muted" aria-hidden="true" />
  );

export const CoverHero = ({ url }: { url?: string | null }) =>
  url ? (
    <VariantImg
      src={url}
      size="400x400"
      surface="coverArt"
      alt=""
      className="aspect-video w-full max-w-xs shrink-0 rounded-xl object-cover sm:w-48"
    />
  ) : (
    <span
      className="hidden aspect-video w-48 shrink-0 rounded-xl bg-muted sm:block"
      aria-hidden="true"
    />
  );
